import { RegExAtLeastOneLower, RegExAtLeastOneNumber, RegExAtLeastOneSymbol, RegExAtLeastOneUpper, RegExMin8Char, Roles } from "../config/constants";

export const isValidEmail = (email: string | null): boolean => {
    const emailRegex =
        /^(([^<>()\\[\]\\.,;:\s@"]+(\.[^<>()\\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
    return emailRegex.test(String(email).toLowerCase());
}

export const isValidPassword = (password: string, isReset: boolean = false): boolean => {
    if (!isReset)
        return password && password.length > 0 ? true : false;
    else
        return RegExMin8Char.test(password) && RegExAtLeastOneLower.test(password) && RegExAtLeastOneNumber.test(password) && RegExAtLeastOneSymbol.test(password) && RegExAtLeastOneUpper.test(password);
}

export const isValidConfirmPassword = (password: any, confirm: any): boolean => {
    return password === confirm;
}

export const isValidOTP = (otp: string): boolean => {
    return otp && otp.length === 6 ? true : false;
}

export const isValidUserProfile = (profile: any, role: string): boolean => {
    if (!profile) return false

    let isValid = profile.name && profile.name.length > 0;
    if (role === Roles.doctor)
        isValid = isValid && profile.registrationId && profile.registrationId.length > 0

    return isValid
}